import { createFileRoute } from '@tanstack/react-router';

import { AdEditPage } from '@/components/admin/ad-edit-page';
import { useAdminEditPageKey } from '@/hooks/use-admin-navigate';
import { adminHead } from '@/lib/seo';
import { adminGetAdFn } from '@/server/functions/admin';
import { adminAdAnalyticsFn } from '@/server/functions/analytics';

export const Route = createFileRoute('/_admin/admin/ads_/$id')({
    component: AdEditRoute,
    head: ({ params }) =>
        adminHead(
            params.id === 'new' ? 'מודעה חדשה' : 'עריכת מודעה',
            `/admin/ads/${encodeURIComponent(params.id)}`,
        ),
    staleTime: 0,
    preloadStaleTime: 0,
    loader: async ({ params }) => {
        if (params.id === 'new') {
            return { ad: null, analytics: null };
        }
        const [ad, analytics] = await Promise.all([
            adminGetAdFn({ data: { id: params.id } }),
            adminAdAnalyticsFn({ data: { adId: params.id } }),
        ]);
        return { ad, analytics };
    },
});

function AdEditRoute() {
    const { ad, analytics } = Route.useLoaderData();
    const formKey = useAdminEditPageKey(
        ad ? `${ad.id}:${String(ad.updatedAt)}` : undefined,
    );
    return (
        <AdEditPage key={formKey} ad={ad} analytics={analytics} />
    );
}
